/* Shop-Produktseite (kjxp): Galerie, Menge, Varianten, Versandbalken mit Warenkorb, Ergänzungen, Kaufleiste. */
(function () {
  var root = document.querySelector('[data-kjxp]');
  if (!root) return;

  var THRESHOLD = Number(root.getAttribute('data-threshold')) || 5000;
  var price = Number(root.getAttribute('data-price')) || 0;
  var variantId = root.getAttribute('data-variant');
  var form = root.querySelector('#kjxp-form');
  var idInput = form && form.querySelector('[name="id"]');
  var qtyInput = root.querySelector('[data-kjxp-qty]');
  var atc = root.querySelector('[data-kjxp-atc]');
  var moneyTpl = root.getAttribute('data-money') || '€{{amount_with_comma_separator}}';
  function money(c) {
    var n = (c / 100).toFixed(2), parts = n.split('.');
    var thou = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var v = moneyTpl.indexOf('amount_with_comma_separator') > -1 ? thou + ',' + parts[1]
      : moneyTpl.indexOf('amount_no_decimals') > -1 ? parts[0] : parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return moneyTpl.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

  /* Galerie: Wischleiste, Punkte, Vorschaubilder */
  var track = root.querySelector('[data-kjxp-track]');
  var dots = [].slice.call(root.querySelectorAll('.kjxp-dots i'));
  var thumbs = [].slice.call(root.querySelectorAll('.kjxp-thumbs [data-kjxp-thumb]'));
  function goTo(i) {
    if (!track) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function mark(i) {
    dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
  }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    mark(0);
  }
  [].slice.call(root.querySelectorAll('[data-kjxp-thumb]')).forEach(function (b) {
    b.addEventListener('click', function () {
      var i = Number(b.getAttribute('data-kjxp-thumb'));
      goTo(i);
      if (b.closest('.kjxp-lineup') && window.innerWidth < 990) root.querySelector('.kjxp-gal').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Menge */
  [].slice.call(root.querySelectorAll('[data-kjxp-step]')).forEach(function (b) {
    b.addEventListener('click', function () {
      qtyInput.value = Math.max(1, qty() + Number(b.getAttribute('data-kjxp-step')));
      updateShip();
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); updateShip(); });

  /* Varianten */
  var vbs = [].slice.call(root.querySelectorAll('[data-kjxp-v]'));
  vbs.forEach(function (b) {
    b.addEventListener('click', function () {
      vbs.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      variantId = b.getAttribute('data-kjxp-v');
      price = Number(b.getAttribute('data-price')) || price;
      var cmp = Number(b.getAttribute('data-cmp')) || 0;
      var av = b.getAttribute('data-av') === 'true';
      if (idInput) { idInput.value = variantId; idInput.disabled = !av; }
      var pEl = root.querySelector('[data-kjxp-price]'); if (pEl) pEl.textContent = money(price);
      var sp = root.querySelector('[data-kjxp-sticky-price]'); if (sp) sp.textContent = money(price);
      var cEl = root.querySelector('[data-kjxp-cmp]');
      if (cEl) { cEl.hidden = !(cmp > price); cEl.textContent = money(cmp); }
      var oEl = root.querySelector('[data-kjxp-offtxt]');
      if (oEl) { oEl.hidden = !(cmp > price); oEl.textContent = '−' + Math.round((1 - price / cmp) * 100) + ' %'; }
      if (atc) {
        atc.disabled = !av;
        atc.querySelector('span').textContent = av ? 'In den Warenkorb' : 'Ausverkauft';
      }
      try {
        var u = new URL(location.href); u.searchParams.set('variant', variantId); history.replaceState(null, '', u);
      } catch (e) {}
      updateShip();
    });
  });

  /* Versandbalken: Warenkorb + dieser Artikel (solange er noch nicht im Warenkorb liegt) */
  var ship = root.querySelector('[data-kjxp-ship]');
  var shipTxt = root.querySelector('[data-kjxp-ship-txt]');
  var bar = root.querySelector('[data-kjxp-bar]');
  var stickyShip = root.querySelector('[data-kjxp-sticky-ship]');
  var addonBox = root.querySelector('[data-kjxp-addon]');
  var addonList = root.querySelector('[data-kjxp-addon-list]');
  var candidates = [];
  try { candidates = JSON.parse(root.querySelector('[data-kjxp-addons]').textContent) || []; } catch (e) {}
  var cart = { total: 0, ids: [], kuji: root.getAttribute('data-kuji-cart') === 'true', loaded: false };
  var added = {};

  function isKujiItem(it) {
    var t = ((it.product_title || '') + ' ' + (it.url || '')).toLowerCase();
    return t.indexOf('ichiban kuji') > -1 || t.indexOf('ichiban-kuji') > -1;
  }
  function loadCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart.total = c.total_price || 0;
        cart.ids = (c.items || []).map(function (it) { return String(it.variant_id); });
        cart.kuji = (c.items || []).some(isKujiItem);
        cart.loaded = true;
        updateShip();
      }).catch(function () {});
  }
  function updateShip() {
    if (!ship) return;
    var inCart = cart.ids.indexOf(String(variantId)) > -1;
    var projected = cart.total + (inCart ? 0 : price * qty());
    var gap = THRESHOLD - projected;
    var free = gap <= 0;
    ship.classList.toggle('is-free', free);
    if (bar) bar.style.width = Math.max(4, Math.min(100, Math.round(projected / THRESHOLD * 100))) + '%';
    var kujiNote = cart.kuji ? ' (die Kuji-Pauschale von 2 € bleibt)' : '';
    if (free) {
      shipTxt.innerHTML = cart.total >= THRESHOLD
        ? '<b>Versand kostenlos</b>, dein Warenkorb liegt über 50 €' + kujiNote
        : '<b>Versand kostenlos</b> mit diesem Artikel' + kujiNote;
    } else {
      shipTxt.innerHTML = 'Noch <b>' + money(gap) + '</b> bis zum <b>kostenlosen Versand</b>';
    }
    if (stickyShip) stickyShip.textContent = free ? 'Versand kostenlos' : 'Noch ' + money(gap) + ' bis versandkostenfrei';
    renderAddons(free ? 0 : gap);
  }
  function renderAddons(gap) {
    if (!addonBox || !addonList) return;
    if (gap <= 0 || !candidates.length) { addonBox.hidden = true; return; }
    var pool = candidates.filter(function (c) { return cart.ids.indexOf(String(c.v)) === -1 || added[c.v]; });
    if (!pool.length) { addonBox.hidden = true; return; }
    /* 1. Artikel, der die Lücke mit dem kleinsten Überschuss schließt, 2. günstigster weiterer */
    var closing = pool.filter(function (c) { return c.p >= gap; }).sort(function (a, b) { return a.p - b.p; })[0];
    var rest = pool.filter(function (c) { return c !== closing; }).sort(function (a, b) { return a.p - b.p; });
    var pick = [closing || rest.shift(), rest[0]].filter(Boolean).slice(0, 2);
    addonList.innerHTML = pick.map(function (c) {
      return '<div class="kjxp-add"><img src="' + c.i + '" alt="" width="44" height="44" loading="lazy"><a href="' + c.u + '"><em>' + money(c.p) + '</em>' + esc(c.t) + '</a>' +
        '<button type="button" data-kjxp-add="' + c.v + '"' + (added[c.v] ? ' disabled' : '') + '>' + (added[c.v] ? '✓ Im Warenkorb' : '+ Dazu') + '</button></div>';
    }).join('');
    addonBox.hidden = false;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Ergänzung in den Warenkorb – gleicher Weg wie das Theme-Formular, damit der Drawer aktualisiert */
  if (addonList) addonList.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kjxp-add]');
    if (!b || b.disabled) return;
    b.disabled = true; b.textContent = '…';
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', b.getAttribute('data-kjxp-add'));
    fd.append('quantity', '1');
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', location.pathname);
    }
    fetch((window.routes && routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.disabled = false; b.textContent = '+ Dazu'; return; }
        added[b.getAttribute('data-kjxp-add')] = true;
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kjxp-addon' });
        if (drawer && drawer.renderContents) { drawer.renderContents(res); drawer.classList.remove('is-empty'); }
        loadCart();
      })
      .catch(function () { b.disabled = false; b.textContent = '+ Dazu'; });
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(loadCart, 150); });
  document.addEventListener('cart:updated', loadCart);
  updateShip();
  loadCart();

  /* Kaufleiste: erst sichtbar, wenn der Kauf-Button nach oben aus dem Bild gescrollt ist */
  var sticky = root.querySelector('[data-kjxp-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var b = sticky.querySelector('[data-kjxp-sticky-btn]');
        if (b) b.tabIndex = on ? 0 : -1;
      });
    }, { threshold: 0 });
    io.observe(atc);
    var sb = sticky.querySelector('[data-kjxp-sticky-btn]');
    if (sb) sb.addEventListener('click', function () {
      if (atc.disabled) return;
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
  }
})();
